import { ComponentStyleConfig } from '@chakra-ui/react';
import { inputTheme } from './inputTheme';

export const selectTheme: ComponentStyleConfig = { ...inputTheme };
